// extracted by mini-css-extract-plugin
module.exports = {"STableWrapper":"Table_STableWrapper__yIbqZ","STable":"Table_STable__jCEiq","STr":"Table_STr__rTjDF","STd":"Table_STd__3UsAj"};